import { Component, Input } from '@angular/core';
import { map } from 'rxjs';
import { BaseComponent } from 'src/app/core/base/base.component';
import { GeneralCatalogViewModel } from 'src/app/model/general/general-catalog.view';
import { generalConsultOrganConstants } from './organ.constants';
import { GeneralConsultOrganService } from './organ.service';

@Component({
  selector: 'ms-consult-organ',
  templateUrl: './organ.component.html',
})
export class GeneralConsultOrganComponent extends BaseComponent {
  readonly screen = generalConsultOrganConstants;
  @Input() turn = -1;
  @Input() readonly = false;
  organs: GeneralCatalogViewModel[] = [];
  mainDetail?: GeneralCatalogViewModel;
  showDetails = false;
  expandSection = true;

  constructor(protected service: GeneralConsultOrganService) {
    super();
  }

  override onInit() {
    this.subscriptions.push(
      this.service.getPatient().subscribe((patient) => {
        if (patient) {
          this.service
            .loadOrgans(this.turn, patient, this.readonly)
            .pipe(
              map((res) => {
                return res.map((item) => {
                  if (item.catalog) {
                    item.filled = true;
                  }
                  return item;
                });
              })
            )
            .subscribe((organs) => {
              this.mainDetail = organs.find((item) => item.id === 'org_sys_00');
              this.organs = organs.filter((item) => item.id !== 'org_sys_00');
            });
        }
      })
    );

    if (!this.readonly) {
      this.handleReadOnlyData();
    }
  }

  private handleReadOnlyData = () => {
    this.subscriptions.push(
      this.service.isSaving().subscribe((saving) => {
        if (saving) {
          const organs: GeneralCatalogViewModel[] = [];
          const edited = this.organs.filter(
            (organ) => organ.details && organ.details.length > 0
          );
          if (
            this.mainDetail &&
            (this.mainDetail.details ?? '').trim().length > 0
          ) {
            for (const detail of edited) {
              const extraLabel = `; ${detail.name}`;
              this.mainDetail.details = this.mainDetail.details?.replace(
                extraLabel,
                ''
              );
            }
            organs.push(this.mainDetail);
          }
          organs.push(...edited);
          this.subscriptions.push(this.service.save(organs).subscribe());
        }
      })
    );
  };

  handleUpdateGlobalField = ($ev: GeneralCatalogViewModel) => {};

  get catalogsName() {
    return this.organs
      .filter((item) => item.details && item.details?.trim().length > 0)
      .map((item) => item.name)
      .join('; ');
  }
}
